module.exports = __webpack_public_path__ + "static/media/gold-star-vector.3bce8b42.svg";